var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenCheckFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM14.2805 8.2805L9.2805 13.2805C9.134 13.427 8.942 13.5 8.75 13.5C8.558 13.5 8.366 13.427 8.2195 13.2805L5.7195 10.7805C5.4265 10.4875 5.4265 10.013 5.7195 9.72C6.0125 9.427 6.487 9.427 6.78 9.72L8.7495 11.6895L13.219 7.22C13.512 6.927 13.9865 6.927 14.2795 7.22C14.5725 7.513 14.573 7.9875 14.2805 8.2805Z",
    fill: "#12B24B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckFilled);
export default __webpack_public_path__ + "static/media/green-check-filled.c34672628ec9e191d6ec7d211de82fb4.svg";
export { ForwardRef as ReactComponent };